const FIREBASE_API_KEY = 'AIzaSyC37_lS2LDZsq4BeQl4BEmAkhcqipGxiDc'

export { FIREBASE_API_KEY }